import { useSmartProp } from '@smartfire/js-block-engine'
import { PanelRow, PanelBody, ToggleControl } from '@wordpress/components'
import { __experimentalUnitControl as UnitControl } from '@wordpress/components'

import { SelectControl } from '@wordpress/components'

/** THE INSPECTOR
 *
 * A unit control component lets the user input a value for the width of the first colum
 * A selection control open a dropdown menu to select when the columns stack
 * A toggle control set first on top or second on top
 */

function Inspector() {
    const [, setResizableWidth] = useSmartProp('resizableWidth')
    const [displayedWidth, setDisplayedWidth] = useSmartProp('displayedWidth')
    const [reverseStack, setReverseStack] = useSmartProp('reverseStack')
    const [stack, setStack] = useSmartProp('stack')

    return (
        <>
            <PanelBody>
                <PanelRow>
                    <UnitControl
                        label={'Set width of first column'}
                        value={displayedWidth}
                        unit="%"
                        units={[]}
                        onChange={(value) => {
                            setResizableWidth(parseInt(value))
                            setDisplayedWidth(parseInt(value))
                        }}
                    />
                </PanelRow>
            </PanelBody>
            <PanelBody>
                <PanelRow>
                    <SelectControl
                        label="Stack"
                        style={{ width: '180px' }}
                        value={stack}
                        options={[
                            { label: 'None', value: 'none' },
                            { label: 'Tablet', value: 'tablet' },
                            { label: 'Mobile', value: 'mobile' },
                        ]}
                        onChange={(newStack) => setStack(newStack)}
                    />
                </PanelRow>
                {stack !== 'none' ? (
                    <PanelRow>
                        <ToggleControl
                            label={reverseStack ? 'Stack Second on Top' : 'Stack First on Top'}
                            checked={reverseStack}
                            onChange={() => {
                                setReverseStack(!reverseStack)
                            }}
                        />
                    </PanelRow>
                ) : (
                    <></>
                )}
            </PanelBody>
        </>
    )
}

export default Inspector
